import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  summary: string;
  category: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  summary,
  category,
  categoryName,
  coverImage,
  author,
  publishDate,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300/80 transition-all duration-300">
      <Link to={`/article/${id}`} className="block cursor-pointer">
        <div className="relative aspect-[16/9] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            title={title}
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-2.5 flex-wrap">
          <Link
            to={`/category/${category}`}
            className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 hover:bg-accent-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-500">{publishDate}</span>
        </div>
        <Link to={`/article/${id}`} className="block cursor-pointer">
          <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {summary}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{author}</span>
          <div className="flex items-center gap-1.5 flex-wrap">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}